// import React, { useState, useEffect, useRef } from 'react';
// import './Registrations.css'
// import { useNavigate } from 'react-router-dom';
// import { Alert } from '@mui/material';
// // import '../VenderMaster/VendorMasterForm.css'
// import '../../CompanyAdmin/VendorsDetails/VenderMaster/VendorMasterForm.css';
// import signup1 from '../../../Assets/signup1.jpg'
// import IconButton from '@mui/material/IconButton';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import axios from 'axios';
// // '../../environment';
// import { Button } from '@mui/material';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import claimproassist from "../../../Assets/claimproimage.png";
// import Header from '../../Home/Header';
// import { ClipLoader } from 'react-spinners';
// import { Link } from 'react-router-dom'
// import signupImage from '../../../Assets/login/signup.webp'
// import item1 from '../../../Assets/login/item1.svg'
// import item2 from '../../../Assets/login/item2.svg'
// import item3 from '../../../Assets/login/item3.svg'
// import loginimage from '../../../Assets/login/login.jpg'
// import Navbar from '../../../Component/Home/Navbar';
// import Footer from "../../../Component/Home/footer/Footer.jsx";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useModal } from '../../../context/ModalContext.jsx';


// const config = {
//     cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
//     ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
// };


// const SignUp = () => {

//     const { openModal, modalData, closeModal } = useModal();


//     const navigate = useNavigate();
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [showDropdownVendor, setShowDropdownVendor] = useState(false);
//     const [showDropdownCustomer, setShowDropdownCustomer] = useState(false);
//     const [states, setStates] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
//     const [isLoadingStates, setIsLoadingStates] = useState(true);
//     const [isLoadingCities, setIsLoadingCities] = useState(true);
//     const [isClickedNext, setIsClickedNext] = useState(false)
//     let [passwordError, setPasswordError] = useState('');
//     const [isHovered, setIsHovered] = useState(false);
//     let [confirmPasswordError, setConfirmPasswordError] = useState('');
//     const [isClicked, setIsClicked] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);
//     const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//     const [emailError, setEmailError] = useState('');
//     const [latitude, setLatitude] = useState("");
//     const [longitude, setLongitude] = useState("");

//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//     useEffect(() => {
//         loadStates();
//     }, []);

//     const loadStates = () => {
//         setIsLoadingStates(true);
//         fetch(`${config.cUrl}/states`, {
//             headers: { "X-CSCAPI-KEY": config.ckey }
//         })
//             .then(response => response.json())
//             .then(data => {
//                 setStates(data);
//                 setIsLoadingStates(false);
//             })
//             .catch(error => {
//                 console.error('Error loading states:', error);
//                 setIsLoadingStates(false);
//             });
//     }
//     const loadCities = (stateCode) => {
//         setIsLoadingCities(true);
//         fetch(`${config.cUrl}/states/${stateCode}/cities`, {
//             headers: { "X-CSCAPI-KEY": config.ckey }
//         })
//             .then(response => response.json())
//             .then(data => {
//                 setCities(data);
//                 setIsLoadingCities(false);
//             })
//             .catch(error => {
//                 console.error('Error loading cities:', error);
//                 setIsLoadingCities(false);
//             });
//     };

//     const [formData, setFormData] = useState({

//         FullName: '',
//         phone: '',
//         joinInType: "",
//         vendorType: '',
//         customerType: '',
//         email: '',
//         // password: "",
//         // country: 'India',
//         // state: '',
//         // district: "",
//         // address: '',
//         // pincode: '',
//         // latitude: "",
//         // longitude: ""       

//     });

//     // console.log("formdata", formData)

//     useEffect(() => {
//         if (latitude !== "") {
//             setFormData(prevFormData => ({
//                 ...prevFormData,
//                 latitude: latitude,
//             }));
//         }
//     }, [latitude]);

//     // Update formData when longitude changes
//     useEffect(() => {
//         if (longitude !== "") {
//             setFormData(prevFormData => ({
//                 ...prevFormData,
//                 longitude: longitude,
//             }));
//         }
//     }, [longitude]);


//     const fullAddress = `${formData.address}, ${formData.district},${formData.pincode}, ${formData.state}`;
//     const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(fullAddress)}`;

//     useEffect(() => {
//         const getLonLat = async () => {
//             try {
//                 console.log("fulladdress", fullAddress)
//                 const response = await axios.get(url);
//                 console.log("response latitude", response.data)
//                 const location = response.data[0];
//                 setLatitude(location.lat);
//                 setLongitude(location.lon);
//                 console.log(`ANMOL Latitudehere: ${location.lat}, Longitudehere: ${location.lon}`)
//             } catch (error) {
//                 // setLocation("An error occurred while fetching the coordinates.");
//             }
//         }
//         getLonLat()
//     }, [fullAddress])

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         // Create a copy of formData
//         let updatedValue = value;

//         if (name === "phone") {
//             console.log("phonenois", value)
//             updatedValue = value.replace(/\D/g, ''); // Remove non-digit characters
//             if (updatedValue && updatedValue[0].match(/[6-9]/)) {
//                 updatedValue = updatedValue.slice(0, 10); // Only keep up to 10 digits if it starts with 6-9
//             } else {
//                 updatedValue = ''; // Return an empty string if the first digit isn't between 6-9
//             }
//             setFormData({
//                 ...formData,
//                 [name]: updatedValue,
//             });
//         }

//         else if (name === "password") {
//             setFormData(prevFormData => ({
//                 ...prevFormData,
//                 [name]: updatedValue
//             }));

//             // Password validation
//             if (!passwordRegex.test(updatedValue)) {
//                 setPasswordError('Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, and a symbol.');
//             } else {
//                 setPasswordError('');
//             }
//             return; // Stop further execution for password
//         }

//         else if (name === "confirmPassword") {
//             setFormData(prevFormData => ({
//                 ...prevFormData,
//                 [name]: updatedValue
//             }));

//             // Confirm Password validation
//             if (!passwordRegex.test(updatedValue)) {
//                 setConfirmPasswordError('Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, and a symbol.');
//             } else {
//                 setConfirmPasswordError('');
//             }
//             return; // Stop further execution for confirmPassword
//         }

//         else if (name === "pincode") {
//             updatedValue = value.replace(/\D/g, '').slice(0, 6); // Allow digits only, limit to 6 characters
//         }

//         else if (name === 'email') {
//             if (!emailPattern.test(value)) {
//                 setEmailError('Invalid email address');
//             } else {
//                 setEmailError('');
//             }
//         }

//         else if (name === "address") {
//             // No modifications for address, leave as is
//             updatedValue = value;
//         }

//         else if (name === 'state') {
//             loadCities(value); // Load cities when state changes
//             setFormData(prevFormData => ({
//                 ...prevFormData,
//                 [name]: updatedValue,
//                 district: "",
//                 address: "",
//                 pincode: ""
//             }));
//             return; // Stop further execution for state change
//         }

//         // Capitalize other fields (excluding email, address, phone, etc.)
//         if (!["email", "address", "phone", "pincode", "state", "district", "password", "confirmPassword"].includes(name)) {
//             updatedValue = value
//                 .split(' ')
//                 .map(word => word.toUpperCase())
//                 .join(' ');
//         }

//         // Update the formData with the new value
//         setFormData(prevFormData => ({
//             ...prevFormData,
//             [name]: updatedValue
//         }));
//     };

//     const validateForm2 = () => {
//         const { customerType, vendorType, ...otherFields } = formData;

//         if (formData.joinInType === 'Customer' && formData.customerType === '') {
//             return `The field Customer type is required.`;
//         }

//         else if (formData.joinInType === 'Vendor' && formData.vendorType === '') {
//             return `The field Vendor type is required.`;
//         }

//         for (const [key, value] of Object.entries(otherFields)) {
//             if (value === "") {
//                 return `The field '${key}' is required.`;
//             }
//         }
//     }

//     const validateEmail = (email) => {
//         const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         return regex.test(email);
//     }

//     const validatePhone = (phone) => {
//         const regex = /^[6-9]\d{9}$/;
//         return regex.test(phone);
//     }

//     const validatePassword = (password) => {
//         const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//         return regex.test(password);
//     };

//     const [width, setWidth] = useState("50%")

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth <= 990) {
//                 setWidth("100%");
//             } else {
//                 setWidth("50%");
//             }
//         };
//         window.addEventListener('resize', handleResize);
//         handleResize();

//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     const [email, setEmail] = useState('');

//     const handleRoleChange = (e) => {
//         setFormData({ ...formData, joinInType: e.target.value });

//         if (modalData.isOpen) {
//             closeModal()
//         }
//     };

//     const handleCustomerTypeChange = (e) => {
//         setFormData({ ...formData, customerType: e.target.value });
//         if (modalData.isOpen) {
//             closeModal()
//         }
//     };

//     const handleVendorTypeChange = (e) => {
//         setFormData({ ...formData, vendorType: e.target.value });
//         if (modalData.isOpen) {
//             closeModal()
//         }
//     };

//     const showSuccessToast = (e) => {
//         toast.success(e);
//     };

//     const showErrorToast = (e) => {
//         toast.error(e);
//     };

//     const emailInputRef = useRef(null)
//     const fullNameInputRef = useRef(null)
//     const phoneInputRef = useRef(null)
//     const joinInTypeInputRef = useRef(null)

//     const customerTypeInputRef = useRef(null)
//     const vendorTypeInputRef = useRef(null)

//     const [errorInputName, setErrorInputName] = useState(null);

//     const btnSubmit = useRef(null)

//     useEffect(() => {

//         if (errorInputName === 'email') {
//             if (modalData.isOpen) {
//                 emailInputRef.current.focus();
//             } else {
//                 setTimeout(() => {
//                     emailInputRef.current?.focus();
//                 }, 10);
//             }
//         }
//         if (errorInputName === 'FullName') {
//             if (modalData.isOpen) {
//                 fullNameInputRef.current.focus();
//             } else {
//                 setTimeout(() => {
//                     fullNameInputRef.current?.focus();
//                 }, 10);
//             }
//         }
//         if (errorInputName === 'phone') {
//             if (modalData.isOpen) {
//                 phoneInputRef.current.focus();
//             } else {
//                 setTimeout(() => {
//                     phoneInputRef.current?.focus();
//                 }, 10);
//             }
//         }
//         if (errorInputName === 'joinInType') {
//             if (modalData.isOpen) {
//                 joinInTypeInputRef?.current?.focus();

//             } else {
//                 setTimeout(() => {
//                     joinInTypeInputRef?.current?.focus();
//                 }, 10);
//             }
//         }
//         if (errorInputName === 'customerType') {
//             if (modalData.isOpen) {
//                 customerTypeInputRef?.current?.focus();

//             } else {
//                 setTimeout(() => {
//                     customerTypeInputRef?.current?.focus();
//                 }, 10);
//             }
//         }
//         if (errorInputName === 'vendorType') {
//             if (modalData.isOpen) {
//                 vendorTypeInputRef.current.focus();
//             } else {
//                 setTimeout(() => {
//                     vendorTypeInputRef.current?.focus();
//                 }, 10);
//             }
//         }


//     }, [modalData.isOpen]);

//     useEffect(() => {

//         const handleKeyDown = (e) => {

//             // const activeElement = document.activeElement;
//             // console.log("Key pressed:", e.key);
//             // console.log("Active element:", activeElement);

//             if (e.key === 'Escape' || e.key === ' ' || e.key === 'Enter') {

//                 // closeModal();
//                 if (!modalData.isOpen) {
//                     closeModal()
//                 }


//             }

//         };

//         document.addEventListener('keydown', handleKeyDown);

//         return () => {
//             document.removeEventListener('keydown', handleKeyDown);
//         };
//     }, [, modalData.isOpen,]);



//     const handleSubmit = async (e) => {
//         console.log('handleSubmit calling: ');

//         e.preventDefault();

//         setErrorInputName(null)

//         if (!validateEmail(formData.email)) {
//             setErrorInputName('email')
//             openModal({
//                 title: 'Error',
//                 body: 'Please enter valid email address',
//                 iconType: 'error',
//                 autoClose: true,
//             });
//             return;
//         }

//         if (formData.FullName === undefined || formData.FullName.trim() === '') {
//             setErrorInputName('FullName')
//             openModal({
//                 title: 'Error',
//                 body: 'Please enter valid name',
//                 iconType: 'error',
//                 autoClose: true,
//             });
//             return;
//         }

//         if (!validatePhone(formData.phone)) {
//             setErrorInputName('phone')
//             openModal({
//                 title: 'Error',
//                 body: 'Please enter valid phone Number',
//                 iconType: 'error',
//                 autoClose: true,
//             });
//             return;
//         }

//         const validationMessage = validateForm2();

//         if (validationMessage) {
//             setAlertInfo({ show: true, message: validationMessage, severity: 'error' });
//             // showErrorToast(validationMessage)
//             // setErrorInputName('email')

//             console.log(validationMessage)

//             if (validationMessage && validationMessage.includes(`joinInType`)) {
//                 setErrorInputName('joinInType')
//                 openModal({
//                     title: 'Error',
//                     body: 'Please select a role',
//                     iconType: 'error',
//                     autoClose: true,
//                 });
//                 return
//             }
//             if (validationMessage && validationMessage.includes(`Customer type`)) {
//                 setErrorInputName('customerType')
//                 openModal({
//                     title: 'Error',
//                     body: 'Please select a role type',
//                     iconType: 'error',
//                     autoClose: true,
//                 });
//                 return
//             }
//             if (validationMessage && validationMessage.includes(`Vendor type`)) {
//                 setErrorInputName('vendorType')
//                 openModal({
//                     title: 'Error',
//                     body: 'Please select a role type',
//                     iconType: 'error',
//                     autoClose: true,
//                 });
//                 return
//             }

//             // openModal({
//             //     title: 'Error',
//             //     body: validationMessage,
//             //     iconType: 'error',
//             //     autoClose: true,
//             // });
//             setIsLoading(false);
//             return;
//         }

//         setIsLoading(true);

//         let sendData = {};

//         const formDataObj = new FormData();
//         for (const key in formData) {
//             if (formData[key]) {
//                 if (formData[key] instanceof File) {
//                     formDataObj.append(key, formData[key], formData[key].name);
//                 } else {
//                     formDataObj.append(key, formData[key]);
//                 }
//             }
//         }

//         for (const key in sendData) {
//             if (sendData[key]) formDataObj.append(key, sendData[key]);
//         }

//         // for (let pair of formDataObj.entries()) {
//         //     console.log(pair[0] + ":" + pair[1])
//         // }

//         console.log(formData);

//         // return

//         try {
//             const response = await axios({
//                 method: 'POST',
//                 url: `${process.env.REACT_APP_BACKEND_URL}/api/signupByUser`,
//                 data: formData,
//             });

//             console.log('Submit response:');
//             console.log(response);

//             if (response.status === 200 || response.status === 201) {
//                 setIsLoading(false);
//                 setErrorInputName(null)

//                 openModal({
//                     title: 'Success',
//                     body: "Registration completed! Please click below to log in.",
//                     iconType: 'success',
//                     autoClose: false,
//                     actionLabel: 'Log In',
//                     onAction: () => {
//                         navigate('/LoginPage')
//                         closeModal();
//                     }
//                 });

//                 setFormData({});
//                 sendData = {};
//             }
//             if (response.data.message == 'We Have An Existing Email !!!') {
//                 setIsLoading(false);
//                 setAlertInfo({ show: true, message: response.data.message, severity: 'error' });
//                 openModal({
//                     title: 'Error',
//                     body: response.data.message,
//                     iconType: 'error',
//                     autoClose: true,
//                 });
//             }

//         } catch (error) {
//             setIsLoading(false);
//             const errorMessage = error.response?.data?.message || 'An error occurred';
//             setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
//             // showErrorToast(errorMessage)
//             openModal({
//                 title: 'Error',
//                 body: errorMessage,
//                 iconType: 'error',
//                 autoClose: true,
//             });
//             // alert()
//         }
//     }

//     useEffect(() => {
//         emailInputRef.current.focus()
//     }, [])


//     return (
//         <>

//             <Navbar />
//             <div className='md:px-0 px-[20px] bg-white pb-10'>
//                 <div className="flex items-center justify-center md:flex-row flex-col-reverse gap-[68px] md:pr-[80px] pr-0">
//                     <div className='max-w-[862px] md:block hidden w-full'>
//                         <img src={signupImage} className='mt-[-115px]' alt="" />
//                     </div>
//                     <div className='max-w-[430px] w-full '>
//                         <h6 className="font-[500] font-satoshi text-[30px] text-[#000000] pt-8 pb-[26px] " >Sign up</h6>
//                         <p className="font-[400] font-satoshi text-[#515151] text-[16px] mb-0 pb-[52px]">Already have an account?
//                             Log in  <Link to="/LoginPage" className='no-underline'><span className='font-[600] text-[#21A6E9]'>here.</span></Link> </p>

//                         {/* <p className="font-[400] font-satoshi text-[#515151] text-[16px] mb-0 pb-[52px] mt-2">You can  <Link to="/LoginPage" className='no-underline'><span className='font-[600] text-[#21A6E9]'>Login here !</span></Link></p> */}

//                         <div className="flex flex-col gap-[9.6vw] md:gap-[42px] ">
//                             <div>
//                                 <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Email</label>
//                                 <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'email' ? 'border-[#FF0000]' : 'border-[#000000]'
//                                     }`}>
//                                     <img src={item1} alt="" className="w-[20px] h-[20px]" />
//                                     <input
//                                         ref={emailInputRef}
//                                         type="text"
//                                         id="email"
//                                         name="email"
//                                         required
//                                         value={formData.email}
//                                         onChange={handleChange}
//                                         className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
//                                         placeholder="Enter your email address"
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter') {

//                                                 btnSubmit.current.click()

//                                                 if (modalData.isOpen) {
//                                                     closeModal()
//                                                 }
//                                             }
//                                         }}
//                                     />
//                                 </div>
//                             </div>
//                             <div>
//                                 <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Full Name</label>
//                                 <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'FullName' ? 'border-[#FF0000]' : 'border-[#000000]'
//                                     }`}>
//                                     <img src={item2} alt="" className="w-[20px] h-[20px]" />
//                                     {/* <input type="text" className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]' placeholder='Enter your User name' /> */}
//                                     <input
//                                         ref={fullNameInputRef}
//                                         type="text"
//                                         id="FullName"
//                                         name="FullName"
//                                         required
//                                         value={formData.FullName}
//                                         onChange={handleChange}
//                                         className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
//                                         placeholder="Enter your Full name"
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter') {

//                                                 btnSubmit.current.click()

//                                                 if (modalData.isOpen) {
//                                                     closeModal()
//                                                 }
//                                             }
//                                         }}
//                                     />
//                                 </div>
//                             </div>

//                             <div>
//                                 <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Mobile No.</label>
//                                 <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'phone' ? 'border-[#FF0000]' : 'border-[#000000]'
//                                     }`}>
//                                     {/* <img src={item2} alt="" className="w-[20px] h-[20px]" /> */}
//                                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
//                                         <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
//                                     </svg>
//                                     <input
//                                         ref={phoneInputRef}
//                                         type="text"
//                                         id="phone"
//                                         name="phone"
//                                         required
//                                         value={formData.phone}
//                                         onChange={handleChange}
//                                         className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
//                                         placeholder="Enter your Mobile No."
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter') {

//                                                 btnSubmit.current.click()

//                                                 if (modalData.isOpen) {
//                                                     closeModal()
//                                                 }


//                                             }
//                                         }}
//                                     />
//                                 </div>

//                             </div>

//                             <div>
//                                 <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Role</label>
//                                 <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'joinInType' ? 'border-[#FF0000]' : 'border-[#000000]'
//                                     }`}>
//                                     <img src={item2} alt="" className="w-[20px] h-[20px]" />
//                                     <select className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]'
//                                         ref={joinInTypeInputRef}

//                                         id="joinInType"
//                                         name="joinInType"
//                                         value={formData.joinInType}
//                                         onChange={handleRoleChange}
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter') {

//                                                 if (modalData.isOpen) {
//                                                     closeModal()
//                                                     e.preventDefault()
//                                                     e.stopPropagation()
//                                                 }

//                                             }
//                                         }}

//                                     >
//                                         <option value="">Role</option>
//                                         <option value="Customer">Customer</option>
//                                         <option value="Vendor">Service Provider</option>
//                                     </select>
//                                 </div>

//                             </div>

//                             {formData.joinInType === "Customer" && (
//                                 <div>
//                                     <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Role Type</label>
//                                     <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'customerType' ? 'border-[#FF0000]' : 'border-[#000000]'
//                                         }`}>
//                                         <img src={item2} alt="" className="w-[20px] h-[20px]" />
//                                         <select className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]'
//                                             ref={customerTypeInputRef}

//                                             id="customerType"
//                                             name="customerType"
//                                             value={formData.customerType}
//                                             onChange={handleCustomerTypeChange}
//                                             onKeyDown={(e) => {
//                                                 if (e.key === 'Enter') {

//                                                     if (modalData.isOpen) {
//                                                         closeModal()
//                                                         e.preventDefault()
//                                                         e.stopPropagation()
//                                                     }

//                                                 }
//                                             }}

//                                         >
//                                             <option value="">Role Type</option>
//                                             <option value="retail">Individual</option>
//                                             <option value="fleetOwner">Company</option>
//                                         </select>
//                                     </div>

//                                 </div>)}

//                             {formData.joinInType === "Vendor" && (
//                                 <div>
//                                     <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Role Type</label>
//                                     <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'vendorType' ? 'border-[#FF0000]' : 'border-[#000000]'
//                                         }`}>
//                                         <img src={item2} alt="" className="w-[20px] h-[20px]" />
//                                         <select className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]'
//                                             ref={vendorTypeInputRef}

//                                             id="vendorType"
//                                             name="vendorType"
//                                             value={formData.vendorType}
//                                             onChange={handleVendorTypeChange}
//                                             onKeyDown={(e) => {
//                                                 if (e.key === 'Enter') {

//                                                     if (modalData.isOpen) {
//                                                         closeModal()
//                                                         e.preventDefault()
//                                                         e.stopPropagation()
//                                                     }

//                                                 }
//                                             }}
//                                         >
//                                             <option value="">Role Type</option>
//                                             <option value="crane">Crane Service</option>
//                                             <option value="mechanic">Mechanic Service</option>
//                                             <option value="recoveryVan">Recovery Van Service</option>

//                                         </select>
//                                     </div>

//                                 </div>)}


//                             <div hidden>
//                                 <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Password</label>
//                                 <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
//                                     <img src={item3} alt="" className="w-[20px] h-[20px]" />
//                                     <input
//                                         type="password"
//                                         id="password"
//                                         name="password"
//                                         required
//                                         value={formData.password}
//                                         onChange={handleChange}
//                                         className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
//                                         placeholder="Enter your Password"
//                                     />
//                                 </div>

//                             </div>
//                             <div hidden>
//                                 <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Confirm Password</label>
//                                 <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
//                                     <img src={item3} alt="" className="w-[20px] h-[20px]" />
//                                     <input
//                                         type="password"
//                                         id="confirmPassword"
//                                         name="confirmPassword"
//                                         required
//                                         value={formData.confirmPassword}
//                                         onChange={handleChange}
//                                         className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
//                                         placeholder="Confirm your Password"
//                                     />
//                                 </div>

//                             </div>
//                             <div>
//                                 {/* {alertInfo.show && (
//                                     <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
//                                         {alertInfo.message}
//                                     </Alert>
//                                 )} */}
//                             </div>
//                             <button ref={btnSubmit} className='bg-[#21A6E9] rounded-[32px] py-[14px] font-[500] font-satoshi text-[17px] text-[#FFFFFF]' onClick={handleSubmit} >
//                                 {isLoading ? 'Registering...' : 'Register'}
//                             </button>
//                             {isLoading && (
//                                 <div className='flex flex-col items-center justify-center mt-[10px]'>
//                                     <ClipLoader color="#21A6E9" loading={isLoading} />
//                                     <div style={{ marginTop: '10px', color: '#21A6E9' }}>Registering you, please wait...</div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>

//     )
// }

// export default SignUp;


import React, { useState, useEffect, useRef } from 'react';
import './Registrations.css'
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';
// import '../VenderMaster/VendorMasterForm.css'
import '../../CompanyAdmin/VendorsDetails/VenderMaster/VendorMasterForm.css';
import signup1 from '../../../Assets/signup1.jpg'
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
// '../../environment';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import claimproassist from "../../../Assets/claimproimage.png";
import Header from '../../Home/Header';
import { ClipLoader } from 'react-spinners';
import { Link } from 'react-router-dom'
import signupImage from '../../../Assets/login/signup.webp'
import item1 from '../../../Assets/login/item1.svg'
import item2 from '../../../Assets/login/item2.svg'
import item3 from '../../../Assets/login/item3.svg'
import loginimage from '../../../Assets/login/login.jpg'
import Navbar from '../../../Component/Home/Navbar';
import Footer from "../../../Component/Home/footer/Footer.jsx";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useModal } from '../../../context/ModalContext.jsx';


const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};


const SignUp = () => {

    const { openModal, modalData, closeModal } = useModal();


    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdownVendor, setShowDropdownVendor] = useState(false);
    const [showDropdownCustomer, setShowDropdownCustomer] = useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [isLoadingStates, setIsLoadingStates] = useState(true);
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [isClickedNext, setIsClickedNext] = useState(false)
    let [passwordError, setPasswordError] = useState('');
    const [isHovered, setIsHovered] = useState(false);
    let [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [isClicked, setIsClicked] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    useEffect(() => {
        loadStates();
    }, []);

    const loadStates = () => {
        setIsLoadingStates(true);
        fetch(`${config.cUrl}/states`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setStates(data);
                setIsLoadingStates(false);
            })
            .catch(error => {
                console.error('Error loading states:', error);
                setIsLoadingStates(false);
            });
    }

    const openLink = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const loadCities = (stateCode) => {
        setIsLoadingCities(true);
        fetch(`${config.cUrl}/states/${stateCode}/cities`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setCities(data);
                setIsLoadingCities(false);
            })
            .catch(error => {
                console.error('Error loading cities:', error);
                setIsLoadingCities(false);
            });
    };

    const [formData, setFormData] = useState({

        FullName: '',
        phone: '',
        joinInType: "",
        vendorType: '',
        customerType: '',
        email: '',
        // password: "",
        // country: 'India',
        // state: '',
        // district: "",
        // address: '',
        // pincode: '',
        // latitude: "",
        // longitude: ""       

    });

    // console.log("formdata", formData)

    useEffect(() => {
        if (latitude !== "") {
            setFormData(prevFormData => ({
                ...prevFormData,
                latitude: latitude,
            }));
        }
    }, [latitude]);

    // Update formData when longitude changes
    useEffect(() => {
        if (longitude !== "") {
            setFormData(prevFormData => ({
                ...prevFormData,
                longitude: longitude,
            }));
        }
    }, [longitude]);


    const fullAddress = `${formData.address}, ${formData.district},${formData.pincode}, ${formData.state}`;
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(fullAddress)}`;

    useEffect(() => {
        const getLonLat = async () => {
            try {
                console.log("fulladdress", fullAddress)
                const response = await axios.get(url);
                console.log("response latitude", response.data)
                const location = response.data[0];
                setLatitude(location.lat);
                setLongitude(location.lon);
                console.log(`ANMOL Latitudehere: ${location.lat}, Longitudehere: ${location.lon}`)
            } catch (error) {
                // setLocation("An error occurred while fetching the coordinates.");
            }
        }
        getLonLat()
    }, [fullAddress])

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Create a copy of formData
        let updatedValue = value;

        if (name === "phone") {
            console.log("phonenois", value)
            updatedValue = value.replace(/\D/g, ''); // Remove non-digit characters
            if (updatedValue && updatedValue[0].match(/[6-9]/)) {
                updatedValue = updatedValue.slice(0, 10); // Only keep up to 10 digits if it starts with 6-9
            } else {
                updatedValue = ''; // Return an empty string if the first digit isn't between 6-9
            }
            setFormData({
                ...formData,
                [name]: updatedValue,
            });
        }

        else if (name === "password") {
            setFormData(prevFormData => ({
                ...prevFormData,
                [name]: updatedValue
            }));

            // Password validation
            if (!passwordRegex.test(updatedValue)) {
                setPasswordError('Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, and a symbol.');
            } else {
                setPasswordError('');
            }
            return; // Stop further execution for password
        }

        else if (name === "confirmPassword") {
            setFormData(prevFormData => ({
                ...prevFormData,
                [name]: updatedValue
            }));

            // Confirm Password validation
            if (!passwordRegex.test(updatedValue)) {
                setConfirmPasswordError('Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, and a symbol.');
            } else {
                setConfirmPasswordError('');
            }
            return; // Stop further execution for confirmPassword
        }

        else if (name === "pincode") {
            updatedValue = value.replace(/\D/g, '').slice(0, 6); // Allow digits only, limit to 6 characters
        }

        else if (name === 'email') {
            if (!emailPattern.test(value)) {
                setEmailError('Invalid email address');
            } else {
                setEmailError('');
            }
        }

        else if (name === "address") {
            // No modifications for address, leave as is
            updatedValue = value;
        }

        else if (name === 'state') {
            loadCities(value); // Load cities when state changes
            setFormData(prevFormData => ({
                ...prevFormData,
                [name]: updatedValue,
                district: "",
                address: "",
                pincode: ""
            }));
            return; // Stop further execution for state change
        }

        // Capitalize other fields (excluding email, address, phone, etc.)
        if (name === 'FullName') {
            updatedValue = value
                .split(' ')
                .map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(' ');
        } else if (!["email", "address", "phone", "pincode", "state", "district", "password", "confirmPassword"].includes(name)) {
            updatedValue = value
                .split(' ')
                .map(word => word.toUpperCase())
                .join(' ');
        }

        // Update the formData with the new value
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: updatedValue
        }));
    };

    const validateForm2 = () => {
        const { customerType, vendorType, ...otherFields } = formData;

        if (formData.joinInType === 'Customer' && formData.customerType === '') {
            return `The field Customer type is required.`;
        }

        else if (formData.joinInType === 'Vendor' && formData.vendorType === '') {
            return `The field Vendor type is required.`;
        }

        for (const [key, value] of Object.entries(otherFields)) {

            if (key !== 'email') {
                if (value === "") {
                    return `The field '${key}' is required.`;
                }
            }
        }
    }

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const validatePhone = (phone) => {
        const regex = /^[6-9]\d{9}$/;
        return regex.test(phone);
    }

    const validatePassword = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return regex.test(password);
    };

    const [width, setWidth] = useState("50%")

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 990) {
                setWidth("100%");
            } else {
                setWidth("50%");
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [email, setEmail] = useState('');

    const handleRoleChange = (e) => {
        setFormData({ ...formData, joinInType: e.target.value });

        if (modalData.isOpen) {
            closeModal()
        }
    };

    const handleCustomerTypeChange = (e) => {
        setFormData({ ...formData, customerType: e.target.value });
        if (modalData.isOpen) {
            closeModal()
        }
    };

    const handleVendorTypeChange = (e) => {
        setFormData({ ...formData, vendorType: e.target.value });
        if (modalData.isOpen) {
            closeModal()
        }
    };

    const showSuccessToast = (e) => {
        toast.success(e);
    };

    const showErrorToast = (e) => {
        toast.error(e);
    };

    const emailInputRef = useRef(null)
    const fullNameInputRef = useRef(null)
    const phoneInputRef = useRef(null)
    const joinInTypeInputRef = useRef(null)

    const customerTypeInputRef = useRef(null)
    const vendorTypeInputRef = useRef(null)

    const [errorInputName, setErrorInputName] = useState(null);

    const btnSubmit = useRef(null)

    useEffect(() => {

        if (errorInputName === 'email') {
            if (modalData.isOpen) {
                emailInputRef.current.focus();
            } else {
                setTimeout(() => {
                    emailInputRef.current?.focus();
                }, 10);
            }
        }
        if (errorInputName === 'FullName') {
            if (modalData.isOpen) {
                fullNameInputRef.current.focus();
            } else {
                setTimeout(() => {
                    fullNameInputRef.current?.focus();
                }, 10);
            }
        }
        if (errorInputName === 'phone') {
            if (modalData.isOpen) {
                phoneInputRef.current.focus();
            } else {
                setTimeout(() => {
                    phoneInputRef.current?.focus();
                }, 10);
            }
        }
        if (errorInputName === 'joinInType') {
            if (modalData.isOpen) {
                joinInTypeInputRef?.current?.focus();

            } else {
                setTimeout(() => {
                    joinInTypeInputRef?.current?.focus();
                }, 10);
            }
        }
        if (errorInputName === 'customerType') {
            if (modalData.isOpen) {
                customerTypeInputRef?.current?.focus();

            } else {
                setTimeout(() => {
                    customerTypeInputRef?.current?.focus();
                }, 10);
            }
        }
        if (errorInputName === 'vendorType') {
            if (modalData.isOpen) {
                vendorTypeInputRef.current.focus();
            } else {
                setTimeout(() => {
                    vendorTypeInputRef.current?.focus();
                }, 10);
            }
        }


    }, [modalData.isOpen]);

    useEffect(() => {

        const handleKeyDown = (e) => {

            // const activeElement = document.activeElement;
            // console.log("Key pressed:", e.key);
            // console.log("Active element:", activeElement);

            if (e.key === 'Escape' || e.key === ' ' || e.key === 'Enter') {

                // closeModal();
                if (!modalData.isOpen) {
                    closeModal()
                }


            }

        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [, modalData.isOpen,]);



    const handleSubmit = async (e) => {
        console.log('handleSubmit calling: ');

        e.preventDefault();

        setErrorInputName(null)

        if (formData.FullName === undefined || formData.FullName.trim() === '') {
            setErrorInputName('FullName')
            openModal({
                title: 'Error',
                body: 'Please enter valid name',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        if (!validatePhone(formData.phone)) {
            setErrorInputName('phone')
            openModal({
                title: 'Error',
                body: 'Please enter valid phone Number',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        // if (!validateEmail(formData.email)) {
        //     setErrorInputName('email')
        //     openModal({
        //         title: 'Error',
        //         body: 'Please enter valid email address',
        //         iconType: 'error',
        //         autoClose: true,
        //     });
        //     return;
        // }

        const validationMessage = validateForm2();

        if (validationMessage) {
            setAlertInfo({ show: true, message: validationMessage, severity: 'error' });
            // showErrorToast(validationMessage)
            // setErrorInputName('email')

            console.log(validationMessage)

            if (validationMessage && validationMessage.includes(`joinInType`)) {
                setErrorInputName('joinInType')
                openModal({
                    title: 'Error',
                    body: 'Please select a role',
                    iconType: 'error',
                    autoClose: true,
                });
                return
            }
            if (validationMessage && validationMessage.includes(`Customer type`)) {
                setErrorInputName('customerType')
                openModal({
                    title: 'Error',
                    body: 'Please select a role type',
                    iconType: 'error',
                    autoClose: true,
                });
                return
            }
            if (validationMessage && validationMessage.includes(`Vendor type`)) {
                setErrorInputName('vendorType')
                openModal({
                    title: 'Error',
                    body: 'Please select a role type',
                    iconType: 'error',
                    autoClose: true,
                });
                return
            }

            // openModal({
            //     title: 'Error',
            //     body: validationMessage,
            //     iconType: 'error',
            //     autoClose: true,
            // });
            setIsLoading(false);
            return;
        }


        setIsLoading(true);

        let sendData = {};

        const formDataObj = new FormData();
        for (const key in formData) {
            if (formData[key]) {
                if (formData[key] instanceof File) {
                    formDataObj.append(key, formData[key], formData[key].name);
                } else {
                    formDataObj.append(key, formData[key]);
                }
            }
        }

        for (const key in sendData) {
            if (sendData[key]) formDataObj.append(key, sendData[key]);
        }

        // for (let pair of formDataObj.entries()) {
        //     console.log(pair[0] + ":" + pair[1])
        // }

        console.log(formData);


        try {
            const response = await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/signupByUser`,
                data: formData,
            });

            console.log('Submit response:');
            console.log(response);

            if (response.status === 200 || response.status === 201) {
                setIsLoading(false);
                setErrorInputName(null)

                openModal({
                    title: 'Success',
                    body: "Registration completed! Please click below to log in.",
                    iconType: 'success',
                    autoClose: false,
                    actionLabel: 'Log In',
                    onAction: () => {
                        navigate('/LoginPage')
                        closeModal();
                    }
                });

                setFormData({});
                sendData = {};
            }
            if (response.data.message == 'We Have An Existing Email !!!') {
                setIsLoading(false);
                setAlertInfo({ show: true, message: response.data.message, severity: 'error' });
                openModal({
                    title: 'Error',
                    body: response.data.message,
                    iconType: 'error',
                    autoClose: true,
                });
            }

        } catch (error) {
            setIsLoading(false);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
            // showErrorToast(errorMessage)
            openModal({
                title: 'Error',
                body: errorMessage,
                iconType: 'error',
                autoClose: true,
            });
            // alert()
        }
    finally{
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fullNameInputRef.current.focus()
    }, [])

    useEffect(() => {
        let newNumber = null;
        if (localStorage.getItem('newNumber')) {
            newNumber = localStorage.getItem('newNumber')
            setFormData({ ...formData, phone: newNumber });
            return
        }
    }, [])

    return (
        <>

            <Navbar />
            <div className='md:px-0 px-[20px] bg-white pb-10'>
                <div className="flex items-center justify-center md:flex-row flex-col-reverse gap-[68px] md:pr-[80px] pr-0">
                    <div className='max-w-[862px] md:block hidden w-full'>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/signup.webp' className='mt-[-115px]' alt="" />
                    </div>
                    {isLoading && (
                        <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                            <div className="loader2 h-[50px] w-[20px]"></div>
                        </div>
                    )}
                    <div className='max-w-[430px] w-full '>
                        <h6 className="font-[500] font-satoshi text-[30px] text-[#000000] pt-8 pb-[26px] " >Sign up</h6>
                        <p className="font-[400] font-satoshi text-[#515151] text-[16px] mb-0 pb-[52px]">Already have an account?
                            Log in  <Link to="/LoginPage" className='no-underline'><span className='font-[600] text-[#21A6E9]'>here.</span></Link> </p>

                        {/* <p className="font-[400] font-satoshi text-[#515151] text-[16px] mb-0 pb-[52px] mt-2">You can  <Link to="/LoginPage" className='no-underline'><span className='font-[600] text-[#21A6E9]'>Login here !</span></Link></p> */}

                        <div className="flex flex-col gap-[9.6vw] md:gap-[42px] ">

                            <div>
                                <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Full Name</label>
                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'FullName' ? 'border-[#FF0000]' : 'border-[#000000]'
                                    }`}>
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item2.svg' alt="" className="w-[20px] h-[20px]" />
                                    {/* <input type="text" className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]' placeholder='Enter your User name' /> */}
                                    <input
                                        ref={fullNameInputRef}
                                        type="text"
                                        id="FullName"
                                        name="FullName"
                                        required
                                        value={formData.FullName}
                                        onChange={handleChange}
                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                        placeholder="Enter your Full name"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {

                                                btnSubmit.current.click()

                                                if (modalData.isOpen) {
                                                    closeModal()
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Mobile No.</label>
                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'phone' ? 'border-[#FF0000]' : 'border-[#000000]'
                                    }`}>
                                    {/* <img src={item2} alt="" className="w-[20px] h-[20px]" /> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                    </svg>
                                    <input
                                        ref={phoneInputRef}
                                        type="text"
                                        id="phone"
                                        name="phone"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        required
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                        placeholder="Enter your Mobile No."
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {

                                                btnSubmit.current.click()

                                                if (modalData.isOpen) {
                                                    closeModal()
                                                }


                                            }
                                        }}
                                    />
                                </div>

                            </div>

                            <div>
                                <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Role</label>
                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'joinInType' ? 'border-[#FF0000]' : 'border-[#000000]'
                                    }`}>
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item2.svg' alt="" className="w-[20px] h-[20px]" />
                                    <select className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]'
                                        ref={joinInTypeInputRef}

                                        id="joinInType"
                                        name="joinInType"
                                        value={formData.joinInType}
                                        onChange={handleRoleChange}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {

                                                if (modalData.isOpen) {
                                                    closeModal()
                                                    e.preventDefault()
                                                    e.stopPropagation()
                                                }

                                            }
                                        }}

                                    >
                                        <option value="">Role</option>
                                        <option value="Customer">Customer</option>
                                        <option value="Vendor">Service Provider</option>
                                    </select>
                                </div>

                            </div>

                            {formData.joinInType === "Customer" && (
                                <div>
                                    <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Role Type</label>
                                    <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'customerType' ? 'border-[#FF0000]' : 'border-[#000000]'
                                        }`}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item2.svg' alt="" className="w-[20px] h-[20px]" />
                                        <select className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]'
                                            ref={customerTypeInputRef}

                                            id="customerType"
                                            name="customerType"
                                            value={formData.customerType}
                                            onChange={handleCustomerTypeChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {

                                                    if (modalData.isOpen) {
                                                        closeModal()
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                    }

                                                }
                                            }}

                                        >
                                            <option value="">Role Type</option>
                                            <option value="retail">Individual</option>
                                            <option value="fleetOwner">Company</option>
                                        </select>
                                    </div>

                                </div>)}

                            {formData.joinInType === "Vendor" && (
                                <div>
                                    <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Role Type</label>
                                    <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'vendorType' ? 'border-[#FF0000]' : 'border-[#000000]'
                                        }`}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item2.svg' alt="" className="w-[20px] h-[20px]" />
                                        <select className='font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151]'
                                            ref={vendorTypeInputRef}

                                            id="vendorType"
                                            name="vendorType"
                                            value={formData.vendorType}
                                            onChange={handleVendorTypeChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {

                                                    if (modalData.isOpen) {
                                                        closeModal()
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                    }

                                                }
                                            }}
                                        >
                                            <option value="">Role Type</option>
                                            <option value="crane">Crane Service</option>
                                            <option value="mechanic">Mechanic Service</option>
                                            <option value="recoveryVan">Recovery Van Service</option>

                                        </select>
                                    </div>

                                </div>)}


                            <div hidden>
                                <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Password</label>
                                <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item3.svg' alt="" className="w-[20px] h-[20px]" />
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        required
                                        value={formData.password}
                                        onChange={handleChange}
                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                        placeholder="Enter your Password"
                                    />
                                </div>

                            </div>
                            <div hidden>
                                <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Confirm Password</label>
                                <div className="flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid border-[#000000] h-[40px] box-border">
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item3.svg' alt="" className="w-[20px] h-[20px]" />
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        required
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                        placeholder="Confirm your Password"
                                    />
                                </div>

                            </div>

                            <div>
                                <label htmlFor="" className='font-[500] font-satoshi text-[13px] text-[#000000] mb-0 pb-[13px]'>Email</label>
                                <div className={`flex items-center gap-[10px] pb-[9px] border-b-[2px] border-solid h-[40px] box-border ${errorInputName === 'email' ? 'border-[#FF0000]' : 'border-[#000000]'
                                    }`}>
                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/login/item1.svg' alt="" className="w-[20px] h-[20px]" />
                                    <input
                                        ref={emailInputRef}
                                        type="text"
                                        id="email"
                                        name="email"
                                        required
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="font-[400] outline-none w-full font-satoshi text-[16px] text-[#515151] h-[24px] leading-[24px] p-0 m-0"
                                        placeholder="Enter your email address"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {

                                                btnSubmit.current.click()

                                                if (modalData.isOpen) {
                                                    closeModal()
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div>
                                {/* {alertInfo.show && (
                                    <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                        {alertInfo.message}
                                    </Alert>
                                )} */}
                            </div>
                            <button ref={btnSubmit} className='bg-[#21A6E9] rounded-[32px] py-[14px] font-[500] font-satoshi text-[17px] text-[#FFFFFF]' onClick={handleSubmit} >
                                {isLoading ? 'Registering...' : 'Register'}
                            </button>
                            {isLoading && (
                                <div className='flex flex-col items-center justify-center mt-[10px]'>
                                    <ClipLoader color="#21A6E9" loading={isLoading} />
                                    <div style={{ marginTop: '10px', color: '#21A6E9' }}>Registering you, please wait...</div>
                                </div>
                            )}
                        </div>


                        <div className='font-satoshi text-[14px] mt-3 text-center space-y-1'>

                            <p>
                                By Registering, I Accept{" "}
                                <span
                                    onClick={() => openLink("/terms_&_condition")}
                                    className="text-blue-400 cursor-pointer"
                                >
                                    T & C
                                </span>{" "}
                                and{" "}
                                <span
                                    onClick={() => openLink("/privacy-policy")}
                                    className="text-blue-400 cursor-pointer"
                                >
                                    Privacy Policy
                                </span>
                            </p>

                            <p>
                                Read Account Deletion Policy{" "}
                                <span
                                    onClick={() => openLink("/delete-account-page")}
                                    className="text-blue-400 cursor-pointer"
                                >
                                    Here
                                </span>
                            </p>

                            <p>
                                Cancellation Refund Policy{" "}
                                <span
                                    onClick={() => openLink("/cancellation-refund-policy")}
                                    className="text-blue-400 cursor-pointer"
                                >
                                    Here
                                </span>
                            </p>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>

    )
}

export default SignUp;




